/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export interface WatermarkTypeOption {
  id: number
  value: string
}

export const getAvailableTypes = (
  type: string,
  translate: (key: string, params?: any) => string
): WatermarkTypeOption[] => {
  let types: WatermarkTypeOption[] = []

  switch (type) {
    case 'horizontalAlignment':
    case 'textAlignment':
      types = [
        { id: 1, value: translate('OPTION_LEFT') },
        { id: 2, value: translate('OPTION_CENTER') },
        { id: 3, value: translate('OPTION_RIGHT') }
      ]
      break
    case 'verticalAlignment':
      types = [
        { id: 1, value: translate('OPTION_TOP') },
        { id: 2, value: translate('OPTION_CENTER') },
        { id: 3, value: translate('OPTION_BOTTOM') }
      ]
      break
    case 'fontStyle':
      types = [
        { id: 0, value: translate('OPTION_REGULAR') },
        { id: 1, value: translate('OPTION_BOLD') },
        { id: 2, value: translate('OPTION_ITALICS') },
        { id: 3, value: translate('OPTION_BOLDITALICS') }
      ]
      break
    case 'fontSize':
      types = [
        { id: 8, value: translate('N_PX', { value: 8 }) },
        { id: 10, value: translate('N_PX', { value: 10 }) },
        { id: 12, value: translate('N_PX', { value: 12 }) },
        { id: 14, value: translate('N_PX', { value: 14 }) },
        { id: 16, value: translate('N_PX', { value: 16 }) },
        { id: 18, value: translate('N_PX', { value: 18 }) },
        { id: 20, value: translate('N_PX', { value: 20 }) },
        { id: 24, value: translate('N_PX', { value: 24 }) },
        { id: 28, value: translate('N_PX', { value: 28 }) },
        { id: 32, value: translate('N_PX', { value: 32 }) },
        { id: 36, value: translate('N_PX', { value: 36 }) },
        { id: 48, value: translate('N_PX', { value: 48 }) },
        { id: 72, value: translate('N_PX', { value: 72 }) },
        { id: 96, value: translate('N_PX', { value: 96 }) },
        { id: 110, value: translate('N_PX', { value: 110 }) },
        { id: 146, value: translate('N_PX', { value: 146 }) }
      ]
      break
  }

  return types
}
